import React from 'react';
import { Button } from './Button';

interface CheckInModalProps {
  isOpen: boolean;
  onAnswer: (productive: boolean) => void;
  soundEnabled?: boolean;
}

export const CheckInModal: React.FC<CheckInModalProps> = ({ isOpen, onAnswer, soundEnabled = true }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200">
      <div
        className={`bg-surface rounded-xl shadow-2xl p-6 max-w-sm w-full border transform transition-all scale-100 ${
          soundEnabled ? 'border-border' : 'border-primary animate-pulse'
        }`}
      >
        <h3 className="text-xl font-bold text-text text-center mb-2">Check In</h3>
        <p className="text-muted text-center mb-6">
          Did you work productively in the last interval?
        </p>
        {!soundEnabled && (
          <p className="text-xs text-no text-center mb-4">Sound is off</p>
        )}
        
        <div className="grid grid-cols-2 gap-4">
          <Button 
            variant="success" 
            size="lg" 
            onClick={() => onAnswer(true)}
            className="w-full h-16 text-lg"
          >
            Yes
          </Button>
          <Button 
            variant="danger" 
            size="lg" 
            onClick={() => onAnswer(false)}
             className="w-full h-16 text-lg"
          >
            No
          </Button>
        </div>
        <p className="text-xs text-center text-muted mt-4">This data is saved to your account.</p>
      </div>
    </div>
  );
};
